// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"274":"c5d17844","746":"a56bf1c4","980":"7f0bae0b","985":"1e511578"}[chunkId] + ".css";
};